import React from 'react';
import './TripCard.css';

const TripCard = ({ trip, vehicle }) => {
  const formatTime = (timeStr) => {
    if (!timeStr) return 'N/A';
    const date = new Date(timeStr);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatNumber = (value, unit = '') => {
    if (value === null || value === undefined || value === '') return 'N/A';
    return `${Number(value).toLocaleString('en-IN')}${unit ? ` ${unit}` : ''}`;
  };

  const getActionIcon = () => {
    switch (trip.action) {
      case 'BOARD':
        return '✅';
      case 'UNBOARD':
        return '⏸️';
      default:
        return '📋';
    }
  };

  const getSLAStatus = () => {
    if (trip.sla_status === 'overdue') {
      return <span className="sla-chip overdue">⏰ Overdue</span>;
    }
    return <span className="sla-chip on-time">✅ On Time</span>;
  };

  return (
    <div className={`trip-card ${trip.action.toLowerCase()}`}>
      <div className="trip-header">
        <div className="trip-action">
          <span className="action-icon">{getActionIcon()}</span>
          <span className="action-text">{trip.action}</span>
          {getSLAStatus()}
        </div>
        <div className="trip-time">
          <span className="time-icon">🕒</span>
          <span className="time-text">{formatTime(trip.action_time)}</span>
        </div>
      </div>

      <div className="trip-content">
        <div className="vehicle-info">
          <div className="info-row">
            <span className="info-label">Vehicle:</span>
            <span className="info-value">{vehicle?.vehicle_number || 'N/A'}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Driver:</span>
            <span className="info-value">{vehicle?.driver_name || 'N/A'}</span>
          </div>
        </div>

        <div className="route-info">
          <div className="route-path">
            <div className="origin">
              <span className="location-icon">📍</span>
              <span className="location-text">{trip.origin || 'N/A'}</span>
            </div>
            <div className="arrow">→</div>
            <div className="destination">
              <span className="location-icon">🏁</span>
              <span className="location-text">{trip.destination || 'N/A'}</span>
            </div>
          </div>
        </div>

        {/* New: RTKM, HSD, Advance Expense section */}
        <div className="trip-metrics">
          <div className="metric-item">
            <span className="metric-label">RTKM</span>
            <span className="metric-value">{formatNumber(trip.rtkm, 'km')}</span>
          </div>
          <div className="metric-item">
            <span className="metric-label">HSD</span>
            <span className="metric-value">{formatNumber(trip.hsd, 'L')}</span>
          </div>
          <div className="metric-item">
            <span className="metric-label">Advance Exp</span>
            <span className="metric-value">
              {trip.advance_exp 
                ? `₹${formatNumber(trip.advance_exp)}` 
                : 'N/A'}
            </span>
          </div>
        </div>

        {trip.notes && (
          <div className="notes-section">
            <span className="notes-label">Notes:</span>
            <p className="notes-text">{trip.notes}</p>
          </div>
        )}

        <div className="trip-meta">
          <div className="meta-item">
            <span className="meta-label">Duration:</span>
            <span className="meta-value">
              {trip.duration_minutes 
                ? `${Math.floor(trip.duration_minutes / 60)}h ${trip.duration_minutes % 60}m`
                : 'N/A'}
            </span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Created:</span>
            <span className="meta-value">{formatTime(trip.created_at)}</span>
          </div>
        </div>
      </div>

      <div className="trip-footer">
        <span className="trip-id">Trip ID: {trip.id}</span>
      </div>
    </div>
  );
};

export default TripCard;